import { defaultShouldDehydrateQuery, type Query } from "@tanstack/react-query";

/**
 * Which queries get written to the persisted (localStorage) cache.
 *
 * Composes the library default with our session exclusion — and the default
 * MATTERS: it only persists SUCCESSFUL queries. Persisting a pending query
 * serializes its in-flight promise as `{}`, which poisons the snapshot — on the
 * next load hydration throws and the whole cache is discarded, silently
 * defeating the instant-paint this persistence exists for. (Easy to trigger by
 * closing the tab within the persister's 1s throttle of any in-flight query.)
 *
 * The session probe is additionally excluded: it gates auth and must always come
 * fresh from the server on load, never from a stale on-disk copy.
 */
export function shouldDehydrateQuery(query: Query): boolean {
  return defaultShouldDehydrateQuery(query) && query.queryKey[0] !== "session";
}
